module.exports = __webpack_public_path__ + "img/dogg.211250af.png";